<template>
  <div class="myCenterCommon__userContent__2fHEF">
    <div class="myCenterCommon__users_layout__title__3CoQ0">
      <h3>个人资料</h3>
      <span>为了确保您的账户安全，请您填写相关安全信息，以备不时之需</span>
    </div>
    <div class="userInfo__users_layout_form__HFPCL">
      <div class="userInfo__users_infoTitle__UKMBL">基本资料</div>
      <div class="userInfo__users_layout_form_item__35aDr">
        <div class="userInfo__users_layout_form_label__2V7le">真实姓名：</div>
        <div class="userInfo__users_layout_form_input__2D3z3">
          <input type="text" data-analytics="button" :value="$store.state.userInfo.realname" placeholder="请输入真实姓名" disabled class="index__Input__tY5CA" style="width: 220px; height: 40px" />
        </div>
      </div>

      <div class="userInfo__users_layout_form_item__35aDr">
        <div class="userInfo__users_layout_form_label__2V7le">出生日期：</div>
        <div class="userInfo__users_layout_form_input__2D3z3">
          <el-date-picker v-model="birthday" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
        </div>
        <input type="hidden" id="birthday" value="" />
      </div>
      <div class="userInfo__users_layout_form_item__35aDr">
        <div class="userInfo__users_layout_form_label__2V7le">邮箱：</div>
        <div class="userInfo__users_layout_form_input__2D3z3">
          <input type="text" data-analytics="button" v-model="email" placeholder="请输入邮箱" class="index__Input__tY5CA" style="width: 220px; height: 40px" />
        </div>
      </div>
      <div class="userInfo__users_layout_form_item__35aDr">
        <div class="userInfo__users_layout_form_label__2V7le">手机号：</div>
        <div class="userInfo__users_layout_form_input__2D3z3">
          <input type="text" data-analytics="button" v-model="mobile" placeholder="请输入手机号" class="index__Input__tY5CA" style="width: 220px; height: 40px" />
        </div>
      </div>
      <button data-analytics="button" @click="isOk" class="index__Button3__1Pn-Q" style="width: 190px; height: 40px; margin: 0px 0px 20px 72px">保存</button>
    </div>
    <div class="userInfo__users_layout__safe__2p69W">
      <div class="userInfo__users_infoTitle__UKMBL">
        账户安全<span class="userInfo__tips__3f00A"
          >如果要修改请<span class="userInfo__call__pMMur"><span @click="$parent.openKefu" style="cursor: pointer">联系客服</span></span></span
        >
      </div>
      <div class="userInfo__users_layout_safe_item__3y_RM">
        <div class="userInfo__users_layout_form_label__2V7le">登录密码：</div>
        <span class="userInfo__users_layout_spanFont__mFW6W">*******</span> <button @click="openpawShow" class="index__Button__It0J4 index__Button2__2-XSS" style="width: 120px; height: 40px; position: absolute; right: 0px; font-size: 14px">修改</button>
      </div>
      <div class="userInfo__users_layout_safe_item__3y_RM">
        <div class="userInfo__users_layout_form_label__2V7le">提款密码：</div>
        <span class="userInfo__users_layout_spanFont__mFW6W">*******</span> <button @click="openpayPawShow" class="index__Button__It0J4 index__Button2__2-XSS" style="width: 120px; height: 40px; position: absolute; right: 0px; font-size: 14px">修改</button>
      </div>
      <div class="el-dialog__wrapper" style="z-index: 999; background: rgb(81 73 73 / 49%)" v-if="pawShow" @click="close">
        <div role="dialog" aria-modal="true" aria-label="修改登录密码" class="el-dialog" style="margin-top: 15vh" @click="retrun">
          <div class="el-dialog__header">
            <span class="el-dialog__title">修改登录密码</span><button @click="close" type="button" aria-label="Close" class="el-dialog__headerbtn"><i class="el-dialog__close el-icon el-icon-close"></i></button>
          </div>
          <div class="el-dialog__body">
            <form class="el-form el-form--inline">
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item">
                  <label class="el-form-item__label" style="width: 150px">原密码</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input v-model="passwordInfo.password" type="password" autocomplete="off" placeholder="请输入原密码" class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item">
                  <label class="el-form-item__label" style="width: 150px">新密码</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input v-model="passwordInfo.paypassword" type="password" autocomplete="off" placeholder="请输入新密码" class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label class="el-form-item__label" style="width: 150px">确认密码</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input type="password" v-model="passwordInfo.newpasword" autocomplete="off" placeholder="请再次输入新密码" class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -10px; margin-right: -10px">
                <div class="el-col el-col-4" style="padding-left: 10px; padding-right: 10px"><div class="grid-content bg-purple"></div></div>
                <div class="el-col el-col-16" style="padding-left: 150px; padding-right: 10px">
                  <button type="button" class="el-button el-button--primary" @click="editPassword(1)"><span>确认操作</span></button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="el-dialog__wrapper" style="z-index: 999; background: rgb(81 73 73 / 49%)" v-if="payPawShow" @click="close">
        <div role="dialog" aria-modal="true" aria-label="修改支付密码" class="el-dialog" style="margin-top: 15vh" @click="retrun">
          <div class="el-dialog__header">
            <span class="el-dialog__title">修改支付密码</span><button type="button" @click="close" aria-label="Close" class="el-dialog__headerbtn"><i class="el-dialog__close el-icon el-icon-close"></i></button>
          </div>
          <div class="el-dialog__body">
            <form class="el-form el-form--inline">
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item">
                  <label class="el-form-item__label" style="width: 150px">原密码</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input v-model="passwordInfo.password" type="password" autocomplete="off" placeholder="请输入原密码" class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item">
                  <label class="el-form-item__label" style="width: 150px">新密码</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input v-model="passwordInfo.paypassword" type="password" autocomplete="off" placeholder="请输入新密码" class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label class="el-form-item__label" style="width: 150px">确认密码</label>
                  <div class="el-form-item__content">
                    <div class="el-input"><input v-model="passwordInfo.newpasword" type="password" autocomplete="off" placeholder="请再次输入新密码" class="el-input__inner" /></div>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -10px; margin-right: -10px">
                <div class="el-col el-col-4" style="padding-left: 10px; padding-right: 10px"><div class="grid-content bg-purple"></div></div>
                <div class="el-col el-col-16" style="padding-left: 150px; padding-right: 10px">
                  <button type="button" class="el-button el-button--primary" @click="editPassword(2)"><span>确认操作</span></button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'center',
  data() {
    return {
      mobile: null,
      email: null,
      birthday: null,
      passwordInfo: {},
      info: {},
      baseURL: '',
      pawShow: false,
      payPawShow: false,
    };
  },
  created() {
    let that = this;
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    that.mobile = userInfo.mobile;
    that.email = userInfo.email;
    that.birthday = userInfo.birthday;
    that.baseURL = sessionStorage.getItem('baseURL') || '';
  },
  methods: {

    editPassword(pasType) {
      let that = this;
      if (!that.passwordInfo.password) {
        that.$parent.showTost(0, '请输入旧密码');
        return;
      }
      if (!that.passwordInfo.paypassword) {
        that.$parent.showTost(0, '请输入新密码');
        return;
      }
      if (that.passwordInfo.password.length < 6) {
        that.$parent.showTost(0, '请输入正确的旧密码长度');
        return;
      }
      if (that.passwordInfo.paypassword.length < 6) {
        that.$parent.showTost(0, '请输入正确的新密码长度');
        return;
      }
      if (!that.passwordInfo.newpasword) {
        that.$parent.showTost(0, '请输入确认密码');
        return;
      }
      if (that.passwordInfo.newpasword != that.passwordInfo.paypassword) {
        that.$parent.showTost(0, '两次密码不一致！');
        return;
      }
      if (that.passwordInfo.password == that.passwordInfo.paypassword) {
        that.$parent.showTost(0, '新旧密码不能一致！');
        that.passwordInfo = {};
        return;
      }
      let url = pasType == 1 ? '/api/editPassword' : '/api/editPayPassword';

      that.$parent.showLoading();
      that.$apiFun.post(url, that.passwordInfo).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        that.$parent.hideLoading();
        if (res.code == 200) {
          that.$parent.showTost(1, '密码修改成功！');
          that.passwordInfo = {};
          that.close();
          if (pasType == 1) {
                    that.$parent.closeDaoTime();
            localStorage.clear();
            sessionStorage.clear();
            that.$store.commit('changUserInfo');
            that.$store.commit('changToken');
            that.$router.push({ path: '/login' });
          }
        }
      });
    },
    isOk() {
      let that = this;
      let info = { email: that.email, mobile: that.mobile, birthday: that.birthday };
      let regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      let regEmail = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      let dateFormat = /^(\d{4})-(\d{2})-(\d{2})$/;
      if (!regExp.test(that.mobile)) {
        that.$parent.showTost(0, '请输入正确手机号');
        return;
      }
      if (!regEmail.test(that.email)) {
        that.$parent.showTost(0, '请输入正确邮箱号');
        return;
      }
      if (!dateFormat.test(that.birthday)) {
        that.$parent.showTost(0, '请输入正确的日期格式：YYYY-MM-DD');
        return;
      }

      that.$parent.showLoading();
      that.$apiFun
        .post('/api/updateuserinfo', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.mobile = info.mobile;
            userInfo.email = info.email;
            userInfo.birthday = info.birthday;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$parent.getUserInfo();
            that.$parent.showTost(1, '操作成功');
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    close() {
      let that = this;
      that.pawShow = false;
      that.payPawShow = false;
      that.info = {};
      that.passwordInfo = {};
    },
    openpawShow() {
      let that = this;
      this.pawShow = true;
      that.info = {};
      that.passwordInfo = {};
    },
    openpayPawShow() {
      let that = this;

      this.payPawShow = true;
      that.info = {};
      that.passwordInfo = {};
    },
    openapl() {
      let that = this;

      this.apl = true;
      that.info = {};
      that.passwordInfo = {};
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    goNav(url) {
      this.$parent.goNav(url);
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
    retrun(event) {
      event.stopPropagation();
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/announcement_modal.css';
@import '../../../static/css/Transfer_81ba8019.f1b60e17.css';
</style>



// WEBPACK FOOTER //
// src/components/mine/center.vue